module.exports = "/assets/data/6dfe3eb18c9735ddfca0dcaf74f13968-B16.data.json";